export default {
  "en": {
    "partner": {
      "actions": {
        "add": "Add",
        "changeProfilePicture": "Change Profile Picture",
        "new": "New Partner",
        "profilePictureFormat": "Should be at least 300x300px",
        "save": "Save",
        "sendinvitation": "Send Invitation",
        "submit": "Save",
        "undoChanges": "Undo"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Once per day (around noon)",
          "hourly": "Every hour",
          "twice_daily": "Twice per day (morning/noon)",
          "weekly": "Once per week (Monday noon)"
        },
        "first_name": "First Name",
        "internal_note": "Internal Note",
        "language": "Language",
        "last_name": "Last Name",
        "phone_landline": "Landline number",
        "phone_mobile": "Mobile number",
        "profession": "Job title",
        "session_ended_at": "Last active at",
        "status": "Status",
        "title": "Title"
      },
      "labels": {
        "addExistingCompany": "Add to existing company",
        "contactDetails": "Contact details",
        "createNewCompany": "Create new company",
        "information": "Profile Information",
        "newTeamMember": "New Partner",
        "notEditable": "Some input fields are no longer editable once a partner is active",
        "partnerAddedState": "<b>Not yet invited</b>. An invitation email will be sent once {partner_name} gets access to a published decision, issue or document.",
        "selectedCompany": "Selected company"
      },
      "toasts": {
        "create": "Partner created",
        "update": "Partner updated"
      },
      "validation": {
        "mustBeEmailAddress": "Valid email address required",
        "needFirstName": "First name required",
        "needLastName": "Last name required",
        "requireEmailAddress": "Email required"
      }
    }
  }
}